import { useState } from "react";
import { hasCodeShape, normalizeCode, type Bundle } from "@otto/lehrgang";
import { cssVar } from "../../../shared/lib/cssVar.js";
import styles from "./StartScreen.module.css";

/**
 * Erster Bildschirm: mit Code oder ohne.
 *
 * Der Gastmodus steht gleichberechtigt daneben – ein Kind, dessen Kärtchen
 * verschwunden ist, soll die Stunde nicht am Anmeldebildschirm verbringen.
 */
export function StartScreen({
  bundle,
  onCode,
  onGuest,
  error,
  loading,
}: {
  bundle: Bundle;
  onCode: (code: string) => void;
  onGuest: () => void;
  error: string | null;
  loading: boolean;
}) {
  const [input, setEingabe] = useState("");
  const normalized = normalizeCode(input);
  const shapeOk = hasCodeShape(normalized);

  return (
    <div className={styles.page}>
      <div className={styles.column}>
        {/* Die Grundstellung als Begrüßung – dieselben Kacheln, die im Lehrgang
          die Tasten zeigen. */}
        <div className={styles.keys}>
          {bundle.keyboard.homeRow.map((key) => (
            <span
              key={key.key}
              className={styles.key}
              style={cssVar({ background: key.color })}
            >
              {key.key}
            </span>
          ))}
        </div>
        <h1 className={styles.title}>Otto tippt los</h1>
        <p className={styles.text}>Hast du ein Kärtchen mit deinem Übungscode?</p>

        <form
          className={styles.card}
          onSubmit={(event) => {
            event.preventDefault();
            if (shapeOk) onCode(normalized);
          }}
        >
          <label className={styles.label} htmlFor="code">
            Dein Übungscode
          </label>
          <input
            id="code"
            className={styles.field}
            value={input}
            onChange={(e) => setEingabe(e.target.value)}
            placeholder="esel-lila-4711"
            autoComplete="off"
            autoCapitalize="none"
            spellCheck={false}
            inputMode="text"
            enterKeyHint="go"
          />
          {/* Zeigt, was wirklich gesendet wird – Kinder tippen Leerzeichen statt
            Bindestriche, und das ist in Ordnung. */}
          {input.trim() !== "" && normalized !== input.trim() && (
            <p className={styles.hint}>Wird gelesen als: {normalized}</p>
          )}
          {error && <p className={styles.error}>{error}</p>}
          <button type="submit" className={styles.button} disabled={!shapeOk || loading}>
            {loading ? "Einen Moment …" : "Los geht's"}
          </button>
        </form>

        <button
          type="button"
          className={styles.guestButton}
          onClick={onGuest}
          disabled={loading}
        >
          Ohne Code üben
        </button>
        <p className={styles.small}>
          Ohne Code bleibt dein Fortschritt nur auf diesem Gerät. Deine Lehrerin oder dein
          Lehrer sieht ihn dann nicht.
        </p>
      </div>
    </div>
  );
}
